<template lang="pug">
  .page
    section
      .text-center
        h1 {{ `HELP ${selectedAudience ? ` > ${selectedAudience.toUpperCase()}` : 'ARTICLES'} ${selectedTopic ? ` > ${selectedTopic.title.toUpperCase()}` : ''}` }}
    section.pt-0
      b-container
        content-loader(:height="7", v-if="alert.loading")
        div(v-else-if="selectedAudience && selectedTopic")
          b-button(@click="clearTopic()")
            font-awesome-icon.mr-2(icon="caret-left")
            span ALL HELP
          div.faq-group(role='tablist', v-for='faq in faqs.filter(item => item.topic_id === selectedTopic.id && item.app_user_role === selectedAudience)', :key="faq.id")
            hr
            a.faq-tile(href='#', v-b-toggle="'accordion-' + kebabMe(faq.title)", variant='primary')
              .mr-3.fa.fa-plus
              span {{ faq.title }}
            b-collapse.pl-4(v-bind:id="'accordion-'+kebabMe(faq.title)", accordion='my-accordion', role='tabpanel')
              p.card-text.mt-3.faq-text {{faq.content}}
              a(v-if="faq.full_article_link", :href="`//${faq.full_article_link}`")
                span.text-primary READ FULL ARTICLE
        .row(v-else-if="selectedAudience")
          .col-12.pb-2
            b-button(@click="clearTopic()")
                font-awesome-icon.mr-2(icon="caret-left")
                span ALL HELP
          .col-md-3.mb-3(v-for="topic in faq_topics.filter(item => relevantTopics.includes(item.id))", :key="topic.id")
            a.help-link.center-xy(@click="selectTopic(topic)")
              span {{ topic.title.toUpperCase() }}
        .row(v-else="")
          .col-md-3.mb-3(v-for="(audience, index) in audiences", :key="index")
            a.help-link.center-xy(@click="selectAudience(audience)")
              span {{ audience.toUpperCase() }}
</template>

<script>

import standardMix from '@/mixins/standardMix';
import router from '@/router';
import { apiService } from '@/services';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      faqs: [],
      faq_topics: [],
      audiences: ['customer', 'artist'],
      selectedTopic: null,
      selectedAudience: null,
    };
  },
  computed: {
    relevantTopics() {
      const relevantFaqs = this.faqs.filter(item => item.app_user_role === this.selectedAudience);
      const releTs = [...new Set(relevantFaqs.map(item => item.topic_id))];
      return releTs;
    },
  },
  methods: {
    selectTopic(topic) {
      this.selectedTopic = topic;
    },
    selectAudience(audience) {
      this.selectedAudience = audience;
    },
    clearTopic() {
      this.selectedTopic = null;
      this.selectedAudience = null;
      router.replace({
        ...router.currentRoute,
        query: {
          topic: undefined,
        },
      });
    },
  },
  async created() {
    try {
      this.loading();
      this.faqs = await apiService.getFaqs();
      this.faq_topics = await apiService.getFaqTopics();
      this.clear();
    } catch (error) {
      this.error('Could not load items');
    }
  },
};
</script>

<style lang="scss" scoped>
  .help-link {
    transition: all 0.5s ease-out;
    border: 1px solid black;
    width: 100%;
    height: 200px;
    // &.uncollapsed {
    //   height: 200px;
    // }
    // &:hover {
    //   background-color: black;
    //   color: white;
    // }
  }
  .faq-text {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Help.vue